import '@babel/polyfill';
import 'vue-svgicon/dist/polyfill';
import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import * as svgicon from 'vue-svgicon';
import VueForm from 'vue-form';
import VueTouch from 'vue-touch';
import VueClipboard from 'vue-clipboard2';
import { i18nMixin, detectLanguage, registerLanguages } from '@wealthbar/i18n';
import * as validators from '@/lib/utils/validators';
import root from './root';
import router from './router';
import store from './store';

/* istanbul ignore next: bootstrap code */
(async function bootstrap() {
  registerLanguages({
    'fr-CA': async () => {
      const lang = await import('../i18n/fr_CA.po');
      return lang.default;
    },
  });
  await detectLanguage();
  Vue.use(Router);
  Vue.use(Meta, { keyName: 'head' });
  Vue.use(svgicon, { tagName: 'svgicon' });
  Vue.use(VueForm, { validators });
  Vue.use(VueTouch, { name: 'v-touch' });
  Vue.use(VueClipboard);

  Vue.config.productionTip = false;

  Vue.mixin(i18nMixin);

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(root),
  });
}());
